import React, { useEffect, useState } from "react"

import InputFieldJs from "../../components/shared/InputField"
import * as ModalModule from "../../components/shared/Modal"

type AnyProps = Record<string, unknown> & { children?: React.ReactNode }
const InputField = InputFieldJs as unknown as React.FC<AnyProps>
const AnimatedModal = ModalModule.AnimatedModal as unknown as React.FC<AnyProps>

type IntakeFormNameModalProps = {
  visible: boolean
  title: string
  initialName?: string
  saveLabel?: string
  onClose: () => void
  onSubmit: (name: string) => void
  loading?: boolean
}

export default function IntakeFormNameModal({
  visible,
  title,
  initialName = "",
  saveLabel = "Save",
  onClose,
  onSubmit,
  loading = false
}: IntakeFormNameModalProps) {
  const [name, setName] = useState(initialName)

  useEffect(() => {
    if (visible) setName(initialName)
  }, [visible, initialName])

  const trimmedName = name.trim()
  const canSave = trimmedName.length > 0 && !loading

  return (
    <AnimatedModal
      visible={visible}
      hideModal={onClose}
      header={title}
      showFooter
      hideSaveButton
      hideCancelButton
      footerButtons={[
        {
          label: "Cancel",
          type: "tertiary",
          onClick: onClose,
          disabled: loading
        },
        {
          label: loading ? "Saving…" : saveLabel,
          type: "primary",
          onClick: () => onSubmit(trimmedName),
          disabled: !canSave || loading
        }
      ]}>
      <InputField
        id="intake-form-name"
        label="Form name"
        placeholder="Enter form name"
        value={name}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => setName(event.target.value)}
        onKeyUp={(event: React.KeyboardEvent<HTMLInputElement>) => {
          if (event.key === "Enter" && canSave) onSubmit(trimmedName)
        }}
        autoComplete="off"
      />
    </AnimatedModal>
  )
}
